import { JSONContent } from '@tiptap/react';
import { RichTextContent } from './RichTextarea';

/** Node types that carry no content of their own. */
const STRUCTURAL_NODE_TYPES = new Set([
  'doc',
  'paragraph',
  'text',
  'hardBreak',
]);

const isJsonContentEmpty = (node: JSONContent | JSONContent[]): boolean => {
  if (Array.isArray(node)) return node.every(isJsonContentEmpty);
  if (node.type && !STRUCTURAL_NODE_TYPES.has(node.type)) return false;
  if (typeof node.text === 'string' && node.text.trim()) return false;
  return !node.content || isJsonContentEmpty(node.content);
};

/**
 * True when rich text content has no meaningful content — e.g. the empty
 * document a cleared editor emits (`{type: 'doc', content: [{type:
 * 'paragraph'}]}`). Whitespace-only text is treated as empty; any
 * non-structural node (image, variable, list, …) counts as content.
 */
export const isRichTextContentEmpty = (content: RichTextContent): boolean => {
  if (!content) return true;
  if (typeof content === 'string') {
    if (/<(img|hr|iframe|video|audio|embed|object)\b/i.test(content)) {
      return false;
    }
    return !content.replace(/<[^>]*>/g, '').trim();
  }
  return isJsonContentEmpty(content);
};
